import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { UserFull } from '@wellesley/openapi'
import { userSlice } from '@wellesley/user/slices/userSlice'
import { DatedMessage, wsSlice, WsSliceState } from '@wellesley/ws'
import { useUserSubscribe } from '../useUserSubscribe'

type HookProps = {
  onUpdate: (user: UserFull) => void
}

export const useCurrentUserUpdate = ({ onUpdate }: HookProps) => {
  const user = useSelector(userSlice.selectors.selectCurrentUser)

  const { subscriptionName } = useUserSubscribe({
    id: 'current-user-update',
    user,
  })

  const userUpdate = useSelector((state: WsSliceState) =>
    wsSlice.selectors.selectLastUpdateFor(state, {
      subscriptionName,
      mode: 'equals',
    }),
  ) as DatedMessage<UserFull> | undefined

  useEffect(() => {
    const updatedUser = userUpdate?.data

    updatedUser && onUpdate(updatedUser)
  }, [userUpdate?.data])
}
